import React, { useMemo } from 'react'
import type { PropsWithChildren } from 'react'
// @ts-expect-error — js only library
import Faye from 'faye'

interface Subscription<T> extends Promise<void> {
  cancel: () => void
  withChannel: (cb: (channel: string, message: T) => void) => void
}

export interface SimplePubSubClient {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
  publish: <TP>(channel: string, message: TP) => Promise<void>
  subscribe: <T>(channel: string, cb?: (message: T) => void) => Subscription<T>
}

const SimplePubSubClientContext =
  React.createContext<SimplePubSubClient | null>(null)

interface SimplePubSubClientProviderProps {
  url: string
}

export const SimplePubSubClientProvider = ({
  url,
  children,
}: PropsWithChildren<SimplePubSubClientProviderProps>) => {
  const client = useMemo(
    () => new Faye.Client(url) as SimplePubSubClient,
    [url]
  )

  return (
    <SimplePubSubClientContext.Provider value={client}>
      {children}
    </SimplePubSubClientContext.Provider>
  )
}

export const useSimplePubSubClient = () => {
  const context = React.useContext(SimplePubSubClientContext)

  if (context === null) {
    throw new Error(
      'useSimplePubSubClient must be used within a SimplePubSubClientProvider component'
    )
  }

  return context
}
